import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';
import kmeans from 'ml-kmeans';

const initialState = fromJS({
    list: {
        isLoading: false,
        data: null,
        selected: []
    },
    assistant: {
        isLoading: false,
        data: null,
        selected: []
    },
    zoom: {
        enabled: false,
        xmin: 0,
        xmax: 0,
        ymin: 0,
        ymax: 0
    }
});

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // training
        case CONSTANTS.ON_HISTORICAL_LIST_IS_LOADING:
            return state.setIn(['list', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_HISTORICAL_LIST:
        {
            const data = payload.data && payload.data.toJS ? payload.data.toJS() : payload.data;
            const mapped = data.map(a => [a.phase, a.watt, a.var || 0]);
            const ans5 = mapped.length >= 5 ? kmeans(mapped, 5) : null;
            const ans10 = mapped.length >= 10 ? kmeans(mapped, 10) : null;
            const ans20 = mapped.length >= 20 ? kmeans(mapped, 20) : null;
            for (let i = 0; i < data.length; i += 1) {
                data[i].c5 = ans5 && i < ans5.clusters.length ? ans5.clusters[i] : 0;
                data[i].c10 = ans10 && i < ans10.clusters.length ? ans10.clusters[i] : 0;
                data[i].c20 = ans20 && i < ans20.clusters.length ? ans20.clusters[i] : 0;
            }
            return state.setIn(['list', 'data'], fromJS(data));
        }

        case CONSTANTS.ON_ASSISTANT_LIST_IS_LOADING:
            return state.setIn(['assistant', 'isLoading'], payload.isLoading);

        case CONSTANTS.ON_ASSISTANT_LIST:
        {
            const data = payload.data && payload.data.toJS ? payload.data.toJS() : payload.data;
            return state.setIn(['assistant', 'data'], fromJS(data));
        }

        case CONSTANTS.ON_TOGGLE_SELECT_ITEM: {
            let selected = state.getIn(['list', 'selected']);
            const idx = selected.findIndex(
                item =>
                    item.p1ts === payload.item.p1ts &&
                    item.p2ts === payload.item.p2ts &&
                    item.p3ts === payload.item.p3ts
            );
            // console.log(idx);
            if(idx < 0){
                // add
                selected = selected.insert(selected.size, payload.item);
                // console.log('added');
            } else {
                // remove
                selected = selected.delete(idx);
                // console.log('removed');
            }
            return state.setIn(['list', 'selected'], selected);
        }

        case CONSTANTS.ON_CLEAR_SELECTION:
            return state.setIn(['list', 'selected'], fromJS([]));

        case CONSTANTS.ON_ZOOM_SELECTION:
            return state
                .setIn(['zoom', 'enabled'], payload.enabled)
                .setIn(['zoom', 'xmin'], payload.xmin)
                .setIn(['zoom', 'xmax'], payload.xmax)
                .setIn(['zoom', 'ymin'], payload.ymin)
                .setIn(['zoom', 'ymax'], payload.ymax);

        default:
            return state;
    }
};

export default reducer;
